export default {
  isBlank: function(obj) {
    if (typeof(obj) == "undefined" || !obj || obj == '') {
      return true
    } else {
      return false
    }
  }
}


// WEBPACK FOOTER //
// ./src/common/blank-valid.js